import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { QFormControl, QMultiSelect, QSelect, QSelectPlaceholder, QText } from '@qualio/ui-components';
import { User } from '../../../types';

export const UserFilter: React.FC<{
  isLoadingUsers: boolean;
  users: User[];
  placeholderText: string;
  label?: string;
  isMultiSelect?: boolean;
  multiSelectName?: string;
  dataCy?: string;
  children?: React.ReactNode;
}> = ({
  isLoadingUsers,
  users,
  placeholderText,
  label,
  isMultiSelect = false,
  multiSelectName = 'owner_ids',
  dataCy = 'user-filter',
}) => {
  const { t } = useTranslation();
  const resolvedLabel = label ?? (isMultiSelect ? t('common.labels.owners') : t('common.labels.owner'));
  const usersOptions = users.map((user) => ({
    value: user.id.toString(),
    label: user.full_name,
  }));

  return (
    <QFormControl label={resolvedLabel} data-cy={dataCy} w="300px">
      {isMultiSelect ? (
        <Controller
          name={multiSelectName}
          render={({ field: { onChange, value } }) => (
            <QMultiSelect
              options={usersOptions}
              aria-label={dataCy}
              onChange={(val) => onChange(val.map((c) => c.value))}
              value={value ?? []}
              isLoading={isLoadingUsers}
            >
              <QSelectPlaceholder>
                <QText>{placeholderText}</QText>
              </QSelectPlaceholder>
            </QMultiSelect>
          )}
        />
      ) : (
        <Controller
          name={'owner_id'}
          render={({ field: { ref: _ref, onChange, value, ...field } }) => (
            <QSelect
              {...field}
              options={usersOptions}
              onChange={(changeObject) => {
                onChange(changeObject?.value ?? '');
              }}
              aria-label="user-filter"
              isClearable={true}
              value={value ?? ''}
              isLoading={isLoadingUsers}
              key={`event-owner-${value}`}
            >
              <QSelectPlaceholder>
                <QText>{placeholderText}</QText>
              </QSelectPlaceholder>
            </QSelect>
          )}
        />
      )}
    </QFormControl>
  );
};

export default UserFilter;
